module.exports = __webpack_public_path__ + "media/images/favicons/48-cd290e157b3b932be5ab37997e9e2922.png";